export const SEARCH_PAGE_SIZE = 20;
